export default "__VITE_ASSET__LQwYecp2__"